import { render } from "./OpenParcours.vue?vue&type=template&id=8c655a3c&scoped=true"
import script from "./OpenParcours.vue?vue&type=script&lang=js"
export * from "./OpenParcours.vue?vue&type=script&lang=js"

import "./OpenParcours.vue?vue&type=style&index=0&id=8c655a3c&scoped=true&lang=css"

import exportComponent from "/Users/vincentblin/Sites/ONET-WA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c655a3c"]])

export default __exports__